import { IConjugationState, IInflectId } from 'models/InflectsModel';

export const TABLE_COLORS = {
  // Header colors
  headerBg: 'linear-gradient(to right, #374151, #4b5563)',
  headerHoverBg: 'linear-gradient(to right, #4b5563, #6b7280)',
  headerText: '#ffffff',

  // Table colors
  borderColor: '#e5e7eb',
  borderColorDark: '#d1d5db',

  // Cell colors
  cellBg: '#ffffff',
  cellAltBg: '#f9fafb',
  cellHoverBg: '#f3f4f6',

  // Icon colors
  trashIcon: '#e5e7eb',
  trashIconHover: '#ef4444',
  trashIconHoverBg: 'rgba(254, 226, 226, 0.3)',
  chevronIcon: '#ffffff',

  // Accent colors
  accentGreen: '#10b981',

  // Text colors
  textPrimary: '#374151',
} as const;

export const TABLE_DIMENSIONS = {
  cellWidth: 160,
  cellPadding: '6px 8px',
  cellMinHeight: 36,
  headerPadding: '16px 20px',
  iconSize: 20,
  accentBarWidth: 4,
  accentBarHeight: 24,
} as const;

export const TABLE_TYPOGRAPHY = {
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  headerFontSize: '20px',
  headerFontWeight: 700,
  cellFontSize: '14px',
  cellFontWeight: 500,
  rowHeaderFontWeight: 600,
  letterSpacing: '0.025em',
} as const;

export const REMOVED_INFLECT: Partial<IInflectId> = {
  word: '',
  conjState: IConjugationState.NO_CONJ,
};
